import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import Tag from '@atlaskit/tag';
import { getTagColor } from '../../utils/coloring';
export var HashTag = function HashTag(_ref) {
  var label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    color: getTagColor(label),
    isRemovable: false
  }, rest, {
    text: '# ' + label
  }));
};